import { post } from '../Services/http';
import {
  ADVERTISE_EMAIL_RECEIVE,
  MAIL_LOADING,
  PRODUCT_EMAIL_RECEIVE,
  PRODUCT_EMAIL_ERROR,
} from '../constants';

export const sendProductAdvertisment = (data) => async (dispatch) => {
  dispatch(mailLoading(true));
  return post('/api/productinfo/advertise', data)
    .then((response) => {
      dispatch(mailLoading(false));
      dispatch(advertismentReceived(response));
    })
    .catch((ex) => dispatch(productEmailError(ex)));
};

export const sendProductMessage = (data) => async (dispatch) => {
  dispatch(mailLoading(true));
  return post('/api/productinfo/question', data)
    .then((response) => {
      dispatch(mailLoading(false));
      dispatch(productEmailReceived(response));
    })
    .catch((ex) => dispatch(productEmailError(ex)));
};

export const sendProductQuotation = (data) => async (dispatch) => {
  dispatch(mailLoading(true));
  return post('/api/productinfo/quotation', data)
    .then((response) => {
      dispatch(mailLoading(false));
      dispatch(productEmailReceived(response));
    })
    .catch((ex) => dispatch(productEmailError(ex)));
};

const advertismentReceived = (response) => {
  return {
    type: ADVERTISE_EMAIL_RECEIVE,
    payload: {
      success: response.ok,
      haveResponded: true,
    },
  };
};

const productEmailError = (error) => {
  return {
    type: PRODUCT_EMAIL_ERROR,
    payload: {
      error: error,
    },
  };
};

const productEmailReceived = (response) => ({
  type: PRODUCT_EMAIL_RECEIVE,
  payload: {
    success: response.ok,
    haveResponded: true,
  },
});

const mailLoading = (shouldLoad) => ({
  type: MAIL_LOADING,
  payload: {
    isLoading: shouldLoad,
  },
});
